exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w60[data-v-0f431b6a] {\n  width: 60%;\n}\n[data-v-0f431b6a] .v-list__tile:not(.v-list__tile--avatar) {\n  height: 32px;\n}\n[data-v-0f431b6a] .v-list__tile:hover {\n  background: #eee;\n}\n.v-dialog__content[data-v-0f431b6a] {\n  z-index: 1030 !important;\n}\n", ""]);

// exports
